/**
 * The sentiment screen's route literal. `./routes.ts` registers it, and a
 * caller elsewhere derives its href from here rather than spelling a second
 * copy (`../../control/paths.ts` exists for the same reason).
 *
 * Relative to the router's `basepath`, like every other route literal.
 */

import { interpolatePath } from '@tanstack/react-router';

export const SENTIMENT_PATH = '/c/$campaignId/sentiment';

export function sentimentPath(campaignId: string): string {
  return interpolatePath({ path: SENTIMENT_PATH, params: { campaignId } }).interpolatedPath;
}
